var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-with-sidebar page-with-light-sidebar"},[_c('admin-sidebar',{attrs:{"tabs":_vm.tabs},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}}),(_vm.currentTab)?_c(_vm.currentTab.component,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }